import { createAction, props } from '@ngrx/store';
import { Pharmacy } from '../../models/pharmacy';
import { PharmacySearchParams } from '../../models/pharmacy-search-params';

export const getPatientPharmacies = createAction('[Pharmacies] Get Patient Pharmacies');

export const getPatientPharmaciesSuccess = createAction(
  '[Pharmacies] Get Patient Pharmacies Success',
  props<{ patientPharmacies: Pharmacy[] | null }>()
);

export const getPatientPharmaciesFailure = createAction(
  '[Pharmacies] Get Patient Pharmacies Failure',
  props<{ error: unknown }>()
);

export const navigateToSearchResults = createAction(
  '[Pharmacies] Navigate to Search Results',
  props<{ searchParams: PharmacySearchParams; medicationId: number }>()
);

export const getPharmaciesSearch = createAction(
  '[Pharmacies] Get Pharmacies Search',
  props<{ searchParams: PharmacySearchParams }>()
);

export const getPharmaciesSearchSuccess = createAction(
  '[Pharmacies] Get Pharmacies Search Success',
  props<{ pharmacies: Pharmacy[] }>()
);

export const getPharmaciesSearchFailure = createAction(
  '[Pharmacies] Get Pharmacies Search Failure',
  props<{ error: unknown }>()
);

export const nextPage = createAction('[Pharmacies] Next Page', props<{ searchParams: PharmacySearchParams }>());

export const getPharmacyById = createAction('[Pharmacies] Get Pharmacy By Id', props<{ pharmacyId: number }>());

export const getPharmacyByIdSuccess = createAction(
  '[Pharmacies] Get Pharmacy By Id Success',
  props<{ pharmacy: Pharmacy }>()
);

export const getPharmacyByIdFailure = createAction(
  '[Pharmacies] Get Pharmacy By Id Failure',
  props<{ error: unknown }>()
);

export const navigateToPatientPharmacies = createAction(
  '[Pharmacies] Navigate to Patient Pharmacies',
  props<{ medicationId: number; pharmacyId: number }>()
);

export const openPharmacySearchDialog = createAction('[Pharmacies] Open Pharmacy Search Dialog');

export const closePharmacySearchDialog = createAction(
  '[Pharmacies] Close Pharmacy Search Dialog',
  props<{ selectedPharmacy: Pharmacy }>()
);

export const cancelPharmacySearchDialog = createAction('[Pharmacies] Close Pharmacy Search Dialog');
